import { takeLatest, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import {
  GET_SUB_CATEGORY_RESOLUTIONS,
  GET_SUB_CATEGORY_RESOLUTIONS_SUCCESS,
  GET_SUB_CATEGORY_RESOLUTIONS_ERROR,
} from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getSubCategoryResolutions({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/ticket-system/sub-categories/resolutions`,
      method: 'GET',
      headers: filteredHeaders,
      params: { subcategory_id: payload.subcategoryId },
    });

    if (response.status === 200) {
      yield put({ type: GET_SUB_CATEGORY_RESOLUTIONS_SUCCESS, payload: response?.data });
    } else {
      yield put({ type: GET_SUB_CATEGORY_RESOLUTIONS_ERROR, payload: response?.data?.message });
    }
  } catch (error) {
    yield put({ type: GET_SUB_CATEGORY_RESOLUTIONS_ERROR, payload: error });
  }
}

export function* watchGetSubCategoryResolutions() {
  yield takeLatest(GET_SUB_CATEGORY_RESOLUTIONS, getSubCategoryResolutions);
}

function* getSubCategoryResolutionsSaga() {
  yield all([fork(watchGetSubCategoryResolutions)]);
}

export default getSubCategoryResolutionsSaga;
